import React from 'react'
import styled from 'styled-components'
import { Text } from 'rebass'
import { useLocation } from 'react-router-dom'

import ImgBox from '../../components/Gamification/ImgBox'
import ExchangeNft from '../../components/Gamification/ExchangeNft'
import { RowColumn } from '../../components/Row'

import { NFTTYPE } from '../../constants/bakery/nft'

const SoccerMain = styled.div`
  width: 890px;
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    width: 100%;
  `};
`
const Main = styled.div`
  width: 100%;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`
const activeClassName = 'ACTIVENAV'

const AutoRowColumn = styled(RowColumn)`
  height: 543px;
`

const Info = styled.div`
  color: ${({ theme }) => theme.bsText7};
  width: 432px;
  height: auto;
  flex: 1;
  margin-top: 25px;
  overflow-y: scroll;
  padding: 16px 30px;
  border-radius: 20px;
  background: ${({ theme }) => theme.bsBg2};
  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 90%;
    height: auto;
    margin: 0 auto;
    margin-bottom: 20px;
  `};
`


export default function Matrix () {
  const location = useLocation()
  return (
    <SoccerMain>
      <Main>
        <ImgBox imgLink={'/images/nft/plusbox.svg'}/>
        <AutoRowColumn>
          <ExchangeNft type={NFTTYPE.MATRIX} />
          <Info className={location.pathname.indexOf('gamification/car') > -1 ? activeClassName : ''}>
            <Text fontSize={18} fontFamily={'Baloo Da'} fontWeight={700}>Matrix+ Box – Batch 1/3, the second 500 boxes</Text>
            <Text fontSize={14} marginTop={20}>What’s the price of the upcoming 500 mystery boxes?</Text>
            <Text fontSize={14} marginTop={20}>10 million RACA per box -or- 600 BUSD per box.</Text>
            <br/>
            <Text fontSize={18} fontFamily={'Baloo Da'} fontWeight={700}>Matrix+ Box is the first and the only Maye Musk Koda Mystery Box.</Text>
            <Text fontSize={14} marginTop={20}>There are 6000 Matrix+ Boxes divided into three batches. Each batch has 2000 boxes.</Text>
            <Text fontSize={14} marginTop={20}>For Batch one, 200 will go to Maye Musk and her team’s crypto wallets, 200 for marketing and operation, and 600 for #RACA to farm. 1000 will be up for sale. We sold the first 500 on June 30 and we are selling 500 on July 3, 5AM,UTC.</Text>
            <Text fontSize={14} marginTop={20}>Each box is programmatically generated with a unique serial number. Your box will come with a random number. You won’t know which number you will get. We won’t know either. That’s why we call them Mystery Boxes. The image on the boxes will be the same. The difference will be the serial numbers of each NFT.</Text>
          </Info>
        </AutoRowColumn>
      </Main>
    </SoccerMain>
  )
}